import { Amplify, type ResourcesConfig } from 'aws-amplify';

/**
 * AWS Amplify Configuration for Masti Manch Platform
 * 
 * This configuration uses Amplify Gen 2 (v6) format.
 * The values are output by the CDK stack and should be set as environment variables
 * or replaced with actual values for each deployment stage.
 */

// Environment variables with fallback values for development
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
const identityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '';
const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || 'https://api.mastimanch.com';
const region = import.meta.env.VITE_CDK_DEFAULT_REGION || 'ap-south-1';
const contentBucket = import.meta.env.VITE_CONTENT_BUCKET || '';

// Check if required configuration is present
const isConfigured = userPoolId && userPoolClientId;

// Default configuration for local development using Amplify Gen 2 format
const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      identityPoolId,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
    },
  },
  API: {
    REST: {
      MastiManchAPI: {
        endpoint: apiEndpoint,
        region,
      },
    },
  },
  Storage: {
    S3: {
      bucket: contentBucket,
      region,
    },
  },
};

// Initialize Amplify
try {
  Amplify.configure(amplifyConfig);
  
  // Log configuration status (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.log('AWS Amplify (Gen 2) configured successfully');
    console.log('Cognito User Pool:', userPoolId?.substring(0, 20) + '...');
    console.log('API Endpoint:', apiEndpoint);
  }
} catch (error) {
  console.error('Failed to configure AWS Amplify (Gen 2):', error);
  
  // Provide fallback configuration for development
  if (process.env.NODE_ENV === 'development') {
    console.warn('Using development fallback configuration');
    
    const fallbackConfig = {
      Auth: {
        Cognito: {
          userPoolId: 'ap-south-1_xxxxxxxxx',
          userPoolClientId: 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
          identityPoolId: 'ap-south-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          loginWith: {
            email: true,
          },
          signUpVerificationMethod: 'code' as const,
        },
      },
      API: {
        REST: {
          MastiManchAPI: {
            endpoint: 'http://localhost:3000/api',
            region: 'ap-south-1',
          },
        },
      },
    };
    
    try {
      Amplify.configure(fallbackConfig);
      console.log('Development fallback configuration applied');
    } catch (fallbackError) {
      console.error('Failed to apply fallback configuration:', fallbackError);
    }
  }
}

// Export configuration for manual use if needed
export default amplifyConfig;